<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div>
        <md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon>
      </div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.subject : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">
        <md-tab id="tab-account" md-label="TaskTemplate" :to="recordPath" exact>
          <div class="md-card md-layout-item md-small-size-100">
            <CustomTaskForm
              :update="updateForm"
              :form="form"
              :$v="$v"
              :formConfig="formConfig"
              :recordData="recordData"
              :headerColor="headerColor"
            ></CustomTaskForm>
          </div>
        </md-tab>
      </md-tabs>
    </template>
  
    <div v-else class="md-layout-item md-small-size-100">
      <CustomTaskForm
        :update="updateForm"
        :form="form"
        :$v="$v"
        :formConfig="formConfig"
        :recordData="recordData"
        :headerColor="headerColor"
      ></CustomTaskForm>
    </div>
  </div>
  
</template>

<script>
import Record from "@/mixins/Record";
import { API, graphqlOperation } from 'aws-amplify';
// Form validations
import { required, numeric, minLength } from "vuelidate/lib/validators";
import * as queries from '@/graphql/queries';
import * as queries_custom from '@/graphql/queries_custom';

export default {
  name: "task",
  mixins: [Record],
  data() {
    return {
      formConfig: {
        hasUpdatedBy: true,
        updatedByFieldName: 'taskUpdatedById',
        updatedByTaskStepFieldName: 'taskStepUpdatedById',
        isTemplateActive: true,
        responseFieldName: "getTask",
        actions: {
          save: "createTask",
          view: "editTask",
          edit: "editTask",
          new: "newTaskTemplate",
          update: "updateTask",
          delete: "deleteTask"
        },
        slots: {
          basic: { label: "Basic Information", icon: "work" , layout: {"x":0,"y":0,"w":6,"h":18,"i":"0"}},
        },
        listPath: "/tasktemplates",
        headerIcon: "assessment",
        objectName: "Task",
        objectNamePlural: "Tasks",
        editMode: false,
        // limit: {
        //   usersLimit: 999
        // },
        redirectTemp: true,
        pageMode: 'new', // can be one of ['new', 'view' 'edit']
        fields: {
          id: { label: "ID", type: "id", slot: "basic" },
          subject: { label: "Subject", type: "text", slot: "basic", uniqueErrorMessage: 'Can not use this name as it is reserved.' },
          type: {
            label: "Type",
            type: "select",
            slot: "basic",
            options: [
              { name: "Application", id: "Application" },
              { name: "Call", id: "Call" },
              { name: "FollowUp", id: "FollowUp" },
              { name: "Meeting", id: "Meeting" },
              { name: "ReviewIncomingMessage", id: "ReviewIncomingMessage" },
              { name: "Other", id: "Other" }
            ]
          },
          priority: {
            label: "Priority",
            type: "select",
            slot: "basic",
            options: [
              { name: "High", id: "High" },
              { name: "Low", id: "Low" },
              { name: "Normal", id: "Normal" },
              { name: "Rush", id: "Rush" },
              { name: "Critical", id: "Critical" }
            ]
          },
          status: {
            label: "Status",
            type: "select",
            slot: "basic",
            options: [
              { name: "Open", id: "Open" },
              { name: "WaitingOnCustomer", id: "WaitingOnCustomer" },
              { name: "OnHold", id: "OnHold" },
              { name: "Completed", id: "Completed" },
              { name: "Closed By Workflow", id: "Closed_By_Workflow" }
            ],
            preventOptSelect:'Closed_By_Workflow'
          },
          taskUserId: { label: "Assignee", type: "autocomplete", slot: 'basic',
            data: [],
            displayFieldOne: 'given_name', 
            displayFieldTwo: 'family_name',
            searchTerm: "",
            options: [],
            linkBase: '#/users/',
            setVal: (val) => {
              this.$v.form.taskUserId.$model = val;
            },
            select: (c) => {(($this) => {
              $this.setVal(c.id);
              $this.searchTerm = c.given_name + ' ' + c.family_name;
            })(this.formConfig.fields.taskUserId)},
            hasValidation: true,
            isLazyLoadEnabled: true,
            lazyLoadListQueryId: 'searchUsers',
            lazyLoadResponseFieldName: 'searchUsers',
            lazyLoadSearchableFields: ['given_name', 'family_name'],
            // change: (search) => {(($this) => {
            //   const data = $this.data;
            //   $this.options = new Promise(resolve => {
            //     window.setTimeout(() => {
            //       if (!search) {
            //         $this.setVal("");
            //         $this.searchTerm = "";
            //         resolve(data)
            //       } else {
            //         const term = search.toLowerCase();
            //         let termGivenName = term.split(' ')[0];
            //         let termFamilyName = term.split(' ')[1];
                    
            //         let resultGivenName = data.filter(({ given_name }) => given_name.toLowerCase() === termGivenName);
            //         let resultFamilyName = data.filter(({ family_name }) => family_name.toLowerCase() === termFamilyName);
            //         if ((!resultGivenName.length) || (!resultFamilyName.length)) {  
            //           $this.setVal("");
            //           $this.searchTerm = "";
            //         }
            //         resolve(data.filter(({ given_name, family_name }) => (given_name + ' ' + family_name).toLowerCase().includes(term)));
            //       }
            //     }, 100)
            //   })
            // })(this.formConfig.fields.taskUserId)}
          },
          isCompleteInOrder: {label: 'Complete In Order', type: 'switch', slot: 'basic' },   
        },
        editTitleField: "name"
      },
      form: {
        id: "",
        subject: "",
        type: "",
        priority: "",
        status: "",
        taskUserId: "",
        isCompleteInOrder: false,
      }
    };
  },
  validations() {
    return {
      form: {
        id: {},
        subject: { required, minLength: minLength(3),
              async isUnique(value) {
                if (value.trim().length < 3) {
                  return true;
                }
                const timeoutInterval = this.isFirstTimeReservedNameCheck ? 0 : 3000;
                this.isFirstTimeReservedNameCheck = false;
                clearTimeout(this.reservedNameValidatorTimeoutId);
                return new Promise(async (resolve, reject) => {
                  this.reservedNameValidatorTimeoutId = setTimeout(async () => {
                    const valueTrimmed = value.trim();
                    let params = {limit:999};
                    params.filter = {esQuery: JSON.stringify({"match": {"hasWorkflow": true }})};                    
                    params.limit = 999;
                    const query = queries_custom['searchTasksSteps'];
                    await API.graphql(graphqlOperation(query, params))
                      .then(result => {
                        if (
                          result.data && 
                          result.data.searchTasks && 
                          result.data.searchTasks.items
                        ) {
                          const index = result.data.searchTasks.items.findIndex(_item => {
                            return _item.subject.toLowerCase() == valueTrimmed.toLowerCase();
                          });
                          if (-1 === index) {
                            return resolve(true);
                          }else if(this.recordData && this.recordData.hasWorkflow){
                            return resolve(true);
                          }
                          return reject(false);
                        }
                        reject(false);
                      })
                      .catch(err => {
                        if (
                          err &&
                          err.errors &&
                          err.errors[0].errorType &&
                          'Elasticsearch:UserIllegalArgumentException' == err.errors[0].errorType
                        ) {
                          resolve(true);
                        }
                        reject(false);
                      });
                  }, timeoutInterval);
                });
              }                        
        },
        type: {required},
        priority: {required},
        status: {required},
        taskUserId: {
          isValid: this.isTaskUserIdValid,
        },
        isCompleteInOrder: {},
      }
    };
  },
  methods: {
      updateFormAfter(data) {

        if (typeof data === 'undefined') return;
        if((typeof data.getTask !== 'undefined') && (data.getTask.user == null))
        {
          this.formConfig.fields.taskUserId.searchTerm = '';  
        }
        (($this) => {
          //$this.data = data.listUsers.items;
          $this.data = [];
          if (this.recordData && this.recordData.user) {
            $this.searchTerm = this.recordData.user.given_name + ' ' + this.recordData.user.family_name;
            this.form.taskUserId = this.recordData.user.id;
          } else {
            if (this.$route.query.taskUserId) {
              this.$v.form.taskUserId.$model = this.$route.query.taskUserId;
              /** try to find the User name */
              let matchingIndex = $this.data.findIndex(
                item => item.id === this.form.taskUserId
              );
              if (matchingIndex >= 0) {
                $this.searchTerm = $this.data[matchingIndex].given_name;
              }
            }
          }
        })(this.formConfig.fields.taskUserId);
      },
      /**
       * Validate task user selection
       * @param {String} value the selected user ID
       * @returns {Promise}
       */
      async isTaskUserIdValid(value) {
        // normalized value
        const valueNormalized = value.toString().trim();
        
        // current field
        const field = this.formConfig.fields.taskUserId;
        
        // value is empty and there is no search term
        if (!valueNormalized && !field.searchTerm) {
          return true;
        }
        
        // clear existing timeout
        clearTimeout(field.timeoutId);
        
        // query name
        const queryName = 'getUser';
        
        // run new validation
        return new Promise(async (resolve, reject) => {
          field.timeoutId = setTimeout(() => {
            API.graphql(graphqlOperation(queries[queryName], { id: valueNormalized }))
              .then(res => {
                const data = res.data[queryName];
                const name = `${data.given_name} ${data.family_name}`;
                if (name === field.searchTerm) {
                    return resolve(true);
                }
                return reject(false);
              })
              .catch(err => {
                return reject(false);
              });
          }, 500);
        });
      },
  }
};
</script>

<style lang="scss" scoped>
.md-tabs .md-tabs-navigation {
  padding-left: 15px;
  color: black;
  display: none;
  .md-tab-nav-button.md-button {
    color: black !important;

    &.active {
      color: black !important;
      border-bottom: 2px solid black;
    }
  }
}

.md-content .md-tabs-container .md-tab > .md-layout-item {
  padding-left: 0;
  padding-right: 0;
}
</style>
